<template>
  <div>
    <fixed-menu-desktop @show-form="modalFormOpened = true" />

    <float-menu-desktop @show-form="modalFormOpened = true" />

    <fixed-menu-mobile @show-form="modalFormOpened = true" />

    <float-menu-mobile @show-form="modalFormOpened = true" />

    <header-component
      @show-form-presentation="modalFormOpened = true"
      @show-form-demonstration="modalFormOpened = true"
    />

    <electronic-overhead @show-form-demonstration="modalFormOpened = true" />

    <electronic-registration />

    <electronic-successfully-completed
      @details-clicked="$refs.faq.openItem(6)"
    />

    <free-period @show-form-presentation="modalFormOpened = true" />

    <electronic-advantages />

    <electronic-requirement />

    <electronic-employees />

    <!--    TODO: временно приняли решение убрать эту секцию-->
    <!--    <electronic-how-started />-->

    <electronic-transition @show-form-presentation="modalFormOpened = true" />

    <electronic-f-a-q ref="faq" />

    <footer-component @requested="modalFormOpened = true" />

    <modal-form-consultation
      :visible="modalFormOpened"
      @close="modalFormOpened = false"
      @requested="modalFormOpened = false"
    />
  </div>
</template>

<script>
import FixedMenuDesktop from '@/components/menu/FixedMenuDesktop'
import FloatMenuDesktop from '@/components/menu/FloatMenuDesktop'
import FixedMenuMobile from '@/components/menu/FixedMenuMobile'
import FloatMenuMobile from '@/components/menu/FloatMenuMobile'
import FooterComponent from '@/components/Footer.vue'
import HeaderComponent from '@/components/Header.vue'
import ElectronicRegistration from '@/components/ElectronicRegistration.vue'
import ElectronicOverhead from '@/components/ElectronicOverhead.vue'
import ElectronicSuccessfullyCompleted from '@/components/ElectronicSuccessfullyCompleted.vue'
import FreePeriod from '@/components/FreePeriod.vue'
import ElectronicAdvantages from '@/components/ElectronicAdvantages.vue'
import ElectronicRequirement from '@/components/ElectronicRequirement.vue'
// import ElectronicHowStarted from '@/components/ElectronicHowStarted.vue'
import ElectronicEmployees from '@/components/ElectronicEmployees.vue'
import ElectronicTransition from '@/components/ElectronicTransition.vue'
import ElectronicFAQ from '@/components/ElectronicFAQ.vue'
import ModalFormConsultation from '@/components/common/Modals/ModalFormConsultation.vue'

export default {
  name: 'LandingPage',
  components: {
    FixedMenuDesktop,
    ElectronicFAQ,
    FloatMenuDesktop,
    ElectronicOverhead,
    ElectronicSuccessfullyCompleted,
    ElectronicRequirement,
    ElectronicTransition,
    // ElectronicHowStarted,
    ElectronicEmployees,
    FixedMenuMobile,
    FloatMenuMobile,
    ElectronicAdvantages,
    HeaderComponent,
    ElectronicRegistration,
    FooterComponent,
    FreePeriod,
    ModalFormConsultation,
  },
  data() {
    return {
      modalFormOpened: false,
    }
  },
  methods: {
    redirectToLegacyPage() {
      const queryParams = window.location.search

      this.$router.push(`/legal/${queryParams}`)
    },
  },
}
</script>

<style lang="sass" scoped>
::v-deep .v-modal
  background: rgba(25, 31, 38, 0.7)
</style>
